import { initPayByBankBackGuard } from "../helpers/payByBankBackGuard";

// Must run before Vue mounts and before any awaited call — see the guard's
// own doc comment for why arming this any later (e.g. inside a component's
// mounted() hook) leaves a real Back press unguarded.
initPayByBankBackGuard("/dashboard/manual-payment");

import Vue from "vue";
import App from "./App.vue";
import router from "./routes";
import store from "./store";
import VueRouterBackButton from "vue-router-back-button";
import vuetify from "../plugins/vuetify";
import "../prototypes";

import(/* webpackChunkName: "qrcode" */ "vue-qrcode-reader").then(
  ({ default: VueQrcodeReader }) => {
    Vue.use(VueQrcodeReader);
  }
);

Vue.config.productionTip = true;

Vue.use(VueRouterBackButton, {
  router,
  ignoreRoutesWithSameName: true,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
